import { GetFieldDefBy } from "./GetFieldDefBy";
import { QSortConfig } from "../CoreApp/QSortConfig";
import { AddSortCriteria } from "./AddSortCriteria";
import { QXDoc } from "../CoreApp/QChartTemplateRule";

export function ValidateSortConfig(sortConfig: QSortConfig, doc: QXDoc): QSortConfig {
  //TODO: Rescope to doc
  var newSort = new QSortConfig();
  newSort.InitConfig(sortConfig.GetSortScope());

  var n = sortConfig.GetNumCriteria();
  for (var i = 0; i < n; i++) {
    var criteria = sortConfig.GetIndexCriteria(i);
    var fieldDef = GetFieldDefBy(doc, criteria.GetFieldID(), false, doc?.IsPositionDocument());
    if (!fieldDef)
      fieldDef = GetFieldDefBy(doc, criteria.GetFieldName(), true, doc?.IsPositionDocument());
    AddSortCriteria(newSort, fieldDef, criteria.GetSortOrder());
  }

  return newSort;
}
